import React from "react";
import { DashboardAttentionEngagementClient } from "../api/contracts";
import {
  engagementSignalReason,
  engagementStatusPresentation,
} from "../config/engagementStatus";
import { ReportHelpTooltip } from "./ReportVisuals";

export function EngagementSignal({
  client,
  unavailableLabel = "Engagement signal unavailable",
}: {
  client: DashboardAttentionEngagementClient | undefined;
  unavailableLabel?: string;
}) {
  if (!client) {
    return (
      <span
        className="cp-engagement-signal-unavailable"
        role="img"
        aria-label={unavailableLabel}
        title={unavailableLabel}
      >
        —
      </span>
    );
  }

  const presentation = engagementStatusPresentation[client.engagementStatus];
  const reason = engagementSignalReason(client);

  return (
    <span
      className="cp-engagement-signal"
      data-engagement-status={client.engagementStatus}
    >
      <ReportHelpTooltip
        label={`${presentation.label} engagement signal`}
        definition={`${presentation.label} · ${reason}`}
        trigger={
          <span className="cp-engagement-status-dot" aria-hidden="true" />
        }
      />
    </span>
  );
}
